import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationSearchmodule = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_21430_12564",
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_21430_12564)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M5 18C5.275 18 5.51042 17.9021 5.70625 17.7063C5.90208 17.5104 6 17.275 6 17C6 16.725 5.90208 16.4896 5.70625 16.2938C5.51042 16.0979 5.275 16 5 16C4.725 16 4.48958 16.0979 4.29375 16.2938C4.09792 16.4896 4 16.725 4 17C4 17.275 4.09792 17.5104 4.29375 17.7063C4.48958 17.9021 4.725 18 5 18ZM5 21.675C6.01667 20.7417 6.77083 19.8937 7.2625 19.1312C7.75417 18.3688 8 17.6917 8 17.1C8 16.1917 7.71042 15.4479 7.13125 14.8687C6.55208 14.2896 5.84167 14 5 14C4.15833 14 3.44792 14.2896 2.86875 14.8687C2.28958 15.4479 2 16.1917 2 17.1C2 17.6917 2.24583 18.3688 2.7375 19.1312C3.22917 19.8937 3.98333 20.7417 5 21.675ZM5 23C3.65833 21.8583 2.65625 20.7979 1.99375 19.8187C1.33125 18.8396 1 17.9333 1 17.1C1 15.85 1.40208 14.8542 2.20625 14.1125C3.01042 13.3708 3.94167 13 5 13C6.05833 13 6.98958 13.3708 7.79375 14.1125C8.59792 14.8542 9 15.85 9 17.1C9 17.9333 8.66875 18.8396 8.00625 19.8187C7.34375 20.7979 6.34167 21.8583 5 23Z",
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M9.5 3C11.3167 3 12.854 3.62936 14.1123 4.8877C15.3706 6.14603 16 7.68333 16 9.5C16 10.2333 15.8837 10.9252 15.6504 11.5752C15.4171 12.2251 15.1001 12.7999 14.7002 13.2998L21 19.5996L19.5996 21L13.2998 14.7002C12.7999 15.1001 12.2251 15.4171 11.5752 15.6504C11.3518 15.7306 11.1229 15.795 10.8896 15.8477C10.7675 15.1726 10.54 14.5358 10.2002 13.9512C11.1516 13.8153 11.9807 13.3943 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.0361 5.08027 10.5378 5.24121 11.0049C5.16125 11.0019 5.08085 11 5 11C4.37952 11 3.78509 11.0885 3.22168 11.2607C3.07532 10.7061 3 10.1196 3 9.5C3 7.68333 3.62936 6.14603 4.8877 4.8877C6.14603 3.62936 7.68333 3 9.5 3ZM5 13C6.05833 13 6.98978 13.3706 7.79395 14.1123C8.33938 14.6154 8.69859 15.2357 8.87402 15.9727C8.48473 15.9399 8.10975 15.8752 7.74805 15.7803C7.60395 15.4415 7.39912 15.1374 7.13086 14.8691C6.55169 14.29 5.84167 14 5 14C4.92869 14 4.85848 14.0046 4.78906 14.0088C4.51271 13.7214 4.26695 13.4213 4.05469 13.1055C4.35759 13.0346 4.67283 13 5 13Z",
				fill: "currentColor"
			})]
		})
	]
});
const ForwardRef = forwardRef(SvgLocationSearchmodule);
export default ForwardRef;
